import {ImageIcon} from "lucide-react";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";

export default function SceneEmpty() {
    return (
        <>
            <title>Szenen | DireDawn</title>
            <DetailPaneState title="Keine Szene ausgewählt"
                             description="Wähle links eine Szene aus oder erstelle eine neue."
                             icon={<ImageIcon className="size-10 opacity-50"/>}/>
        </>
    );
}
